// eslint-disable-next-line import/no-anonymous-default-export
export const color = {
  WHITE: "#FFFFFF",
  FHGREEN: "#338F86",
  // Darker brand teal for TEXT on white backgrounds. FHGREEN (#338F86) has a
  // 3.88:1 contrast ratio on white — below the WCAG AA 4.5:1 minimum for
  // normal-size text (axe: color-contrast, serious). This shade measures
  // 5.23:1. Keep FHGREEN for fills/borders/large text; use this for links
  // and body-size text on light backgrounds.
  FHGREEN_TEXT: "#2A7870",
  // Hover shade for brand-green links (Forgot your password?, Platform
  // Agreement, Risk Disclosure Statement). Same 5.23:1 contrast as
  // FHGREEN_TEXT — hovering shifts the hue to a more saturated teal, not
  // the contrast ratio. Same value as FHGREEN_ACCENT below, kept as its own
  // name so these link call sites say what the colour is for.
  FHGREEN_LINK_HOVER: "#007A70",
  // Brand teal for borders, accents, and selected states (nav icons/text,
  // download-button outlines). 5.23:1 on white — safe for text too.
  FHGREEN_ACCENT: "#007A70",
  // Brighter brand teal for fills, borders and LARGE text only. 3.58:1 on
  // white — fails AA for body-size text (4.5:1) but clears the 3:1 floor for
  // non-text UI and for large text (≥24px, or ≥18.66px bold). Anything
  // smaller takes FHGREEN_ACCENT or FHGREEN_TEXT.
  FHGREEN_BRIGHT: "#00988C",
  TEXTGREY: "#4F566B",
  FHADMIN: "#3786D6",
  ADMINHEADING: "#595959",
  DISABLED: "#cccccc",
  REJECT: "#FF0000",
  LOANTEXT: "#31332C",
  GREYBG: "#D9DCE1",
  BGGREY: "#D9DCE1",
  primaryButtonBackground: "#333",
  primaryButtonText: "#fff",
  agreementFont: "#338F86",
  greyColor: "#cccccc",
  whiteColor: "#FFFFFF",
  darkGreyColor: "#979797",
};

// Sidebar / mobile drawer surface. Deep brand green — the same panel colour the
// accredited-investor chip sits on, so the nav and the chip read as one system.
export const SIDEBAR_DARK = "#12332E";
// Nav link pill text — same slate colour at rest and on hover; only the
// background tints on hover, so hovering doesn't change how the text reads.
export const NAV_LINK_TEXT = "#475569";
export const NAV_LINK_BG = "#FFFFFF";
// Nav link icon — same slate-grey at rest and on hover, one shade darker
// than the label so the two still read as a pair.
export const NAV_LINK_ICON = "#64748B";
// Pale mint tint behind a nav link on hover AND for the current route —
// only the icon/text colour tells the two states apart.
export const NAV_LINK_TINT_BG = "#DBF1EF";
// Current-route icon + text — brand teal, distinct from the resting slate.
export const NAV_LINK_SELECTED_ICON = color.FHGREEN_ACCENT;
export const NAV_LINK_SELECTED_TEXT = color.FHGREEN_ACCENT;

/**
 * Semantic status palette: one accent/background pair per meaning, shared by
 * the offer-room, withdrawal and Investment Portfolio status pills so a colour
 * means the same thing in every table.
 */
export interface StatusTone {
  /** Badge text / left-border accent. */
  accent: string;
  /** Badge background tint. */
  bg: string;
}

export const STATUS_TONE: Record<
  "positive" | "info" | "warning" | "negative" | "neutral",
  StatusTone
> = {
  positive: { accent: "#12B886", bg: "#E6FCF5" },
  info: { accent: "#4C6EF5", bg: "#EDF2FF" },
  warning: { accent: "#F76707", bg: "#FFF4E6" },
  negative: { accent: "#F03E3E", bg: "#FFF0F0" },
  neutral: { accent: "#868E96", bg: "#F1F3F5" },
};
